import { Stack } from '@mui/material'
import {
  faCloud,
  faTemperatureHigh,
  faTemperatureLow,
  faUmbrella,
  faWind,
  faStopwatch20,
  faSmog,
  faClock,
} from '@fortawesome/free-solid-svg-icons'
import { EnvironmentDataField } from './EnvironmentDataField'
import { EnvironmentDataSelectField } from './EnvironmentDataSelectField'
import { SelectOption } from '@/components'
import { useFormContext } from 'react-hook-form'
import { VisitLogFormData } from '@/components/forms'
import {
  FOG_LEVEL_MIST_BOVEN_WATERGANGEN,
  FOG_LEVEL_DICHTE_MIST,
} from '@/constants'
import { useEffect } from 'react'

export const EnvironmentDataFieldsSet = (): JSX.Element => {
  const { watch, setValue } = useFormContext<VisitLogFormData>()
  const fogLevel = watch('fog_level')
  const showFogDuration =
    fogLevel === FOG_LEVEL_MIST_BOVEN_WATERGANGEN ||
    fogLevel === FOG_LEVEL_DICHTE_MIST

  const precipitationOptions: SelectOption[] = [
    {
      name: 'Droog',
      value: 'Droog',
    },
    {
      name: 'Motregen',
      value: 'Motregen',
    },
    {
      name: 'Miezer',
      value: 'Miezer',
    },
    {
      name: 'Regen',
      value: 'Regen',
    },
    {
      name: 'Onweer',
      value: 'Onweer',
    },
  ]

  const fogLevelOptions: SelectOption[] = [
    {
      name: 'Geen mist',
      value: 'geen mist',
    },
    {
      name: 'Mist boven watergangen',
      value: FOG_LEVEL_MIST_BOVEN_WATERGANGEN,
    },
    // {
    //   name: 'Lage mist',
    //   value: 'lage mist',
    // },
    {
      name: 'Dichte mist',
      value: FOG_LEVEL_DICHTE_MIST,
    },
  ]

  useEffect(() => {
    if (!showFogDuration) {
      setValue('fog_duration', '')
    }
  }, [showFogDuration])

  return (
    <Stack direction="column" spacing={6}>
      <Stack direction="row" spacing={6}>
        <EnvironmentDataField
          iconName={faTemperatureLow}
          field="start_temperature"
          fieldLocalization="startTemperature"
        />
        <EnvironmentDataField
          iconName={faTemperatureHigh}
          field="end_temperature"
          fieldLocalization="endTemperature"
        />
        <EnvironmentDataField
          iconName={faWind}
          field="wind_force"
          fieldLocalization="windForce"
        />
        <EnvironmentDataField
          iconName={faCloud}
          field="cloud_cover"
          fieldLocalization="cloudCover"
        />
        <EnvironmentDataSelectField
          iconName={faUmbrella}
          field="precipitation"
          options={precipitationOptions}
        />
        <EnvironmentDataField
          iconName={faStopwatch20}
          field="precipitation_duration"
          fieldLocalization="precipitationDuration"
        />
      </Stack>
      <Stack direction="row" spacing={6}>
        <EnvironmentDataSelectField
          iconName={faSmog}
          field="fog_level"
          options={fogLevelOptions}
          fieldLocalization="fogLevel"
        />
        {showFogDuration && (
          <EnvironmentDataField
            iconName={faClock}
            field="fog_duration"
            fieldLocalization="fogDuration"
          />
        )}
      </Stack>
    </Stack>
  )
}
